import { render } from "./MedicineDetailArticle.vue?vue&type=template&id=87ac37ee"
import script from "./MedicineDetailArticle.vue?vue&type=script&lang=js"
export * from "./MedicineDetailArticle.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__